import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["estruturacao-de-processos-comerciais"];

export const Route = createFileRoute("/estruturacao-de-processos-comerciais")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/estruturacao-de-processos-comerciais" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/estruturacao-de-processos-comerciais" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
